
import { Sparkles } from "lucide-react";
import SubscriptionForm from "./SubscriptionForm";

const SubscriptionSection = () => {
  return (
    <div className="glass-card p-8 border-futuristic-border/40 max-w-3xl mx-auto">
      <div className="flex items-center justify-center mb-6">
        <div className="relative">
          <Sparkles className="h-10 w-10 text-blog-neon" />
          <div className="absolute -inset-1 rounded-full blur-lg bg-blog-neon/30 -z-10"></div>
        </div>
      </div>
      <h2 className="text-2xl sm:text-3xl font-bold text-center mb-2">Subscribe to AI Genesis</h2>
      <p className="text-muted-foreground text-center mb-6">
        Get notified when new articles are published. No spam, unsubscribe anytime.
      </p>
      <SubscriptionForm className="max-w-md mx-auto" />
    </div>
  );
};

export default SubscriptionSection;
